var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpertise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1FBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7238 14.3435C19.8388 14.1079 20.1611 14.1079 20.2761 14.3435L20.9541 15.7332C20.9991 15.8254 21.0836 15.8896 21.1815 15.9059L22.6551 16.151C22.9049 16.1926 23.0045 16.5123 22.8258 16.6993L21.7708 17.8043C21.701 17.8775 21.6687 17.9811 21.6841 18.0833L21.9166 19.6253C21.9561 19.8865 21.6954 20.0842 21.4698 19.9642L20.1406 19.2569C20.0523 19.2098 19.9476 19.2098 19.8593 19.2569L18.5301 19.9642C18.3046 20.0842 18.0439 19.8865 18.0833 19.6253L18.3158 18.0833C18.3312 17.9811 18.299 17.8775 18.2291 17.8043L17.1741 16.6993C16.9955 16.5123 17.095 16.1926 17.3448 16.151L18.8185 15.9059C18.9164 15.8896 19.0009 15.8254 19.0459 15.7332L19.7238 14.3435Z",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8334 17.5C25.8334 20.7217 23.2217 23.3333 20 23.3333C16.7784 23.3333 14.1667 20.7217 14.1667 17.5C14.1667 14.2783 16.7784 11.6667 20 11.6667C23.2217 11.6667 25.8334 14.2783 25.8334 17.5Z",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 23.6187L22.1886 27.2094C22.4617 27.9329 22.5983 28.2947 22.8358 28.3333C23.0739 28.2982 23.3656 27.9003 23.6506 27.181C23.8548 26.6659 23.9568 26.4084 24.1671 26.2696C24.2316 26.227 24.3021 26.1933 24.3766 26.1696C24.6196 26.0923 24.8991 26.1679 25.4581 26.319C26.0557 26.4806 26.4709 26.4355 26.6348 26.319C26.6831 26.2847 26.6348 26.3164 26.6348 26.3164C26.7313 26.1452 26.6011 25.8782 26.3406 25.3442L24.5467 21.6667",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1666 23.6184L17.8113 27.2086C17.5382 27.9319 17.2681 28.2947 17.0306 28.3333C16.7925 28.2982 16.6499 27.9386 16.3648 27.2193C16.1607 26.7044 16.0431 26.4077 15.8329 26.2688C15.7684 26.2262 15.6979 26.1927 15.6233 26.1689C15.3803 26.0917 15.1008 26.1672 14.5419 26.3183C13.9442 26.4798 13.5291 26.4322 13.3651 26.3157C13.2686 26.1446 13.3989 25.8776 13.6593 25.3437L15.4532 21.6667",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertise);
export default __webpack_public_path__ + "static/media/Expertise.1749d4f0e7160f0862cbf2a15b6883b1.svg";
export { ForwardRef as ReactComponent };